export const OPENAI_API_KEY = '';
export const OPENAI_DEFAULT_SYSTEM_PROMPT: string = ''
export const ROUTE_PREFIX : string = '/chat';
